<main class="container mt-3">
  <div class="row">
    <div class="col col-12 col-lg-6 offset-lg-3">
      <h1 class="title"><i class="fa fa-exclamation-circle"></i>{{ title }}</h1>
      <p-card>
        <p>Failed to login, please try again.</p>
      </p-card>
    </div>
  </div>
</main>
